<template>
    <div class="row">
        <div class="edit-container">
            <div class="column-sidebar-left">
                <EditDetails v-if="isMounted" :details="details" />
                <EditForumSettings v-if="isMounted" :settings="forumSettings" />
            </div>
            <div class="column-main-right">
                <EditBio v-if="isMounted" :bioInfo="bioInfo" />
                <EditSignature v-if="isMounted" :signatureInfo="signatureInfo" />
                <EditSubscriptions v-if="isMounted"/>
            </div>
        </div>
    </div>
</template>

<script>
    import api from '../../api/api'
    import settings from '../../modules/settings'
    import common from '../../modules/common'
    import EditDetails from '../../components/Member/EditDetails.vue'
    import EditBio from '../../components/Member/EditBio.vue'
    import EditSignature from '../../components/Member/EditSignature.vue'
    import EditForumSettings from '../../components/Member/EditSettings.vue'
    import EditSubscriptions from '../../components/Member/EditSubscriptons.vue'
    

    export default {
        props: ['id'],
        components: {
            EditDetails,
            EditBio,
            EditSignature,
            EditForumSettings,
            EditSubscriptions
        },
        data() {
            return {
                isMounted: false,
                details: {},
                bioInfo: {},
                signatureInfo: {},
                forumSettings: {}        
            }
        },
        mounted() {

            api.get('/members/'  + this.id + '/edit')
                .then(response => {

                    let r = response.data;
                    
                    this.details.id = this.id;
                    this.details.firstName = r.firstName;
                    this.details.lastName = r.lastName;
                    this.details.email = r.email;
                    this.details.country = r.country;
                    this.details.stateProvince = r.stateProvince;
                    this.details.city = r.city;
                    this.details.showLocation = r.showLocation;
                    this.details.website = r.website;
                    this.details.interests = r.interests;
                    this.details.avatarUrl = r.avatarUrl;

                    this.bioInfo.id = this.id
                    this.bioInfo.bio = r.bio;
                    
                    this.signatureInfo.id = this.id;
                    this.signatureInfo.signature = r.signature;

                    this.forumSettings.dateFormat = settings.user.getDateFormat();
                    this.forumSettings.timeFormat = settings.user.getTimeFormat();
                    this.forumSettings.postFormat = settings.user.getPostFormat();
                    this.forumSettings.postOrder = settings.user.getPostOrder();
                    this.forumSettings.postsPerPage = settings.user.getPostsPerPage();
                    this.forumSettings.topicsPerPage = settings.user.getTopicsPerPage();
                    this.forumSettings.useMessaging = settings.user.getUseMessaging();
                    this.forumSettings.useEmoticons = settings.user.getUseEmoticons();
                    this.forumSettings.viewSignatures = settings.user.getViewSignatures();
                    this.forumSettings.viewAvatars = settings.user.getViewAvatars();
                    this.forumSettings.selectedTheme = settings.user.getSelectedTheme();
                    this.forumSettings.fontSize = settings.user.getFontSize();
                    this.forumSettings.fontColor = settings.user.getFontColor();
                    this.forumSettings.fontWeight = settings.user.getFontWeight();
                    this.forumSettings.autoSubscribeTopicReplySiteNotification = settings.user.getAutoSubscribeTopicReplySiteNotification();
                    this.forumSettings.autoSubscribeTopicReplyEmail = settings.user.getAutoSubscribeTopicReplyEmail();
                    this.forumSettings.autoSubscribeTopicCreateSiteNotification = settings.user.getAutoSubscribeTopicCreateSiteNotification();
                    this.forumSettings.autoSubscribeTopicCreateEmail = settings.user.getAutoSubscribeTopicCreateEmail();
                    this.forumSettings.codeFontSize = settings.user.getCodeFontSize();
                    this.forumSettings.useCkEditor = settings.user.getUseCKEditor();

                    var bc = common.breadcrumb.create([
                        { url: '/', text: 'UtterAccess' },
                        { url: '/members/' + this.id + '/edit', text: 'Members > ' +  r.displayName + ' > Edit' }
                    ]);
                    this.$store.dispatch("breadcrumb", bc);

                    this.isMounted = true;
                }
            );
        }
    }
</script>
